/* Zoba — theme.js (bağımlılıksız) */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header gölgesi */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* Mobil menü */
  var drawer = document.querySelector('[data-drawer]');
  if (drawer) {
    var lastFocus = null;
    var open = function () { lastFocus = document.activeElement; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; var f = drawer.querySelector('button, a'); if (f) f.focus(); };
    var close = function () { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); };
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-drawer-close], .drawer__nav a').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }

  /* Duyuru çubuğu döngüsü (mobil) */
  document.querySelectorAll('[data-rotate]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announce__item');
    if (items.length < 2) return;
    var i = 0; items[0].classList.add('is-active');
    if (reduce) return;
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 3500);
  });

  /* Görünür olunca yumuşak giriş */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }

  /* Galeri: kaydırma + küçük resimler + noktalar */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('.gallery__main');
    var slides = g.querySelectorAll('.gallery__slide');
    var thumbs = g.querySelectorAll('.gallery__thumb');
    var dots = g.querySelectorAll('.gallery__dots span');
    if (!track || !slides.length) return;
    var setActive = function (idx) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
    };
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { track.scrollTo({ left: slides[k].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); setActive(k); });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { var idx = Math.round(track.scrollLeft / track.clientWidth); setActive(Math.max(0, Math.min(slides.length - 1, idx))); ticking = false; });
    }, { passive: true });
    setActive(0);
  });

  /* Paket seçici → varyant, fiyat, URL, yapışkan buton */
  var fmt = function (cents) {
    var v = Math.round(cents / 100);
    return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ₺';
  };
  document.querySelectorAll('[data-picker]').forEach(function (picker) {
    var form = document.getElementById(picker.getAttribute('data-form'));
    var priceEl = document.querySelector('[data-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyLabel = document.querySelector('[data-sticky-label]');
    picker.addEventListener('change', function (e) {
      var r = e.target; if (!r || r.name !== 'id') return;
      var shown = r.dataset.priceFmt || fmt(+r.dataset.price);
      if (priceEl) priceEl.textContent = shown;
      if (stickyPrice) stickyPrice.textContent = shown;
      if (stickyLabel) stickyLabel.textContent = r.dataset.label;
      if (form) { var hidden = form.querySelector('input[name="id"]'); if (hidden) hidden.value = r.value; }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', r.value); history.replaceState({}, '', u.toString()); } catch (err) {}
      document.dispatchEvent(new CustomEvent('zoba:variant-change', { detail: { id: +r.value } }));
    });
  });

  /* Yapışkan satın al (mobil) */
  var sticky = document.querySelector('[data-sticky-cta]');
  var anchor = document.querySelector('[data-buy-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-cta');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        /* Satın al bloğu ekranın üstünde kaldıysa göster */
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }).observe(anchor);
    sticky.querySelector('[data-sticky-go]').addEventListener('click', function (e) {
      e.preventDefault();
      /* Önce kapıda ödeme uygulamasının butonunu dene, yoksa forma kaydır */
      var cod = document.querySelector('.product__info #rsi_buy_now_button, .product__info [data-cod-button]');
      if (cod) { cod.click(); return; }
      anchor.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
  }

  /* Enerji hesaplayıcı */
  document.querySelectorAll('[data-calc]').forEach(function (c) {
    var hours = c.querySelector('[name="hours"]');
    var tariff = c.querySelector('[name="tariff"]');
    var hoursOut = c.querySelector('[data-hours-out]');
    var hourOut = c.querySelector('[data-out-hour]');
    var dayOut = c.querySelector('[data-out-day]');
    var monthOut = c.querySelector('[data-out-month]');
    var kwhOut = c.querySelector('[data-out-kwh]');
    var tl = function (n) { return n.toLocaleString('tr-TR', { minimumFractionDigits: n < 100 ? 2 : 0, maximumFractionDigits: n < 100 ? 2 : 0 }) + ' ₺'; };
    var run = function () {
      var kw = +(c.querySelector('[name="mode"]:checked') || { value: 2 }).value;
      var h = +hours.value;
      var t = parseFloat(String(tariff.value).replace(',', '.')) || 0;
      hoursOut.textContent = h + ' saat';
      hourOut.textContent = tl(kw * t);
      dayOut.textContent = tl(kw * h * t);
      monthOut.textContent = tl(kw * h * t * 30);
      kwhOut.textContent = (kw * h * 30).toLocaleString('tr-TR') + ' kWh';
    };
    c.addEventListener('input', run); c.addEventListener('change', run); run();
  });

  /* Sepet adet butonları */
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(0, (+input.value || 0) + (+b.dataset.step));
        input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
})();

/* Açılış · birleşen cihaz: kaydırma ilerlemesine göre kare dizisi canvas'a çizilir */
(function () {
  'use strict';
  var hx = document.querySelector('[data-assemble]');
  if (!hx) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { hx.classList.add('is-static'); return; }
  var n = parseInt(hx.getAttribute('data-frames'), 10) || 0;
  var base = hx.getAttribute('data-frame-base');
  var q = hx.getAttribute('data-frame-query') || '';
  var pin = hx.querySelector('.hx__pin');
  var canvas = hx.querySelector('.hx__canvas');
  var ctx = canvas.getContext('2d');
  if (!n || !base || !ctx) { hx.classList.add('is-static'); return; }
  var imgs = new Array(n), loaded = 0, current = -1, target = 0;
  var pad = function (i) { return ('00' + i).slice(-3); };
  function draw(i) {
    var im = imgs[i];
    while (i > 0 && !(im && im.complete && im.naturalWidth)) { i--; im = imgs[i]; }
    if (!im || !im.naturalWidth || i === current) return;
    if (canvas.width !== im.naturalWidth) { canvas.width = im.naturalWidth; canvas.height = im.naturalHeight; }
    ctx.drawImage(im, 0, 0);
    current = i;
  }
  function load(i) {
    var im = new Image(); im.decoding = 'async';
    im.onload = function () { loaded++; if (i === 0) { draw(0); hx.classList.add('is-ready'); } if (i === target) draw(i); };
    im.src = base + 'hxseq-' + pad(i) + '.webp' + q;
    imgs[i] = im;
  }
  /* Önce ilk kare ve seyrek kareler, sonra hepsi */
  load(0);
  for (var s = 8; s < n; s += 8) load(s);
  for (var k = 1; k < n; k++) if (!imgs[k]) load(k);
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var top = parseFloat(getComputedStyle(pin).top) || 0;
      var total = hx.offsetHeight - pin.offsetHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, (top - hx.getBoundingClientRect().top) / total)) : 1;
      hx.style.setProperty('--hp', p.toFixed(3));
      target = Math.round(p * (n - 1));
      draw(target);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();

/* Müşteri memnuniyeti: dokununca durdur, büyüt */
(function () {
  'use strict';
  var root = document.querySelector('[data-rvm]');
  if (!root) return;
  var dlg = document.querySelector('[data-rvm-dialog]');
  var img = dlg && dlg.querySelector('[data-rvm-img]');
  var cap = dlg && dlg.querySelector('[data-rvm-cap]');
  document.querySelectorAll('[data-rvm-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!dlg || !dlg.showModal) { window.open(b.dataset.full, '_blank'); return; }
      img.hidden = false; img.src = b.dataset.full; img.alt = b.getAttribute('aria-label') || '';
      cap.textContent = b.dataset.cap || '';
      root.classList.add('is-paused');
      dlg.showModal();
    });
  });
  if (dlg) {
    dlg.addEventListener('close', function () { root.classList.remove('is-paused'); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-rvm-close]')) dlg.close(); });
  }
  /* Mobilde dokununca durup devam etsin */
  root.addEventListener('touchstart', function () { root.classList.add('is-paused'); }, { passive: true });
  root.addEventListener('touchend', function () { setTimeout(function () { if (!dlg || !dlg.open) root.classList.remove('is-paused'); }, 1800); }, { passive: true });
})();
